import React from 'react';
import Header from './Header';
import Footer from './Footer';
import CursorGlow from './CursorGlow';

interface LayoutProps {
    children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
    return (
        <div className="relative min-h-screen overflow-x-clip bg-dark-base text-white">
            {/* Ambient glow that trails the cursor. It sits at z-0 and each
                section is individually z-1 with no background of its own, so the
                glow reads through them — hence no stacking context on <main>. */}
            <a href="#main" className="skip-link">
                Skip to content
            </a>
            <CursorGlow />
            <Header />
            <main id="main">{children}</main>
            <Footer />
        </div>
    );
};

export default Layout;
